import { Typography } from '@mui/material'
import { useCatalogCodeHandoff } from '@/hooks/useCatalogCodeHandoff'

/**
 * INVARIANT (Catalog↔Chat death-loop): while `?code=` is present, never render
 * `children` — even if `busy` is false. Rendering the router tree here lets
 * `/` → `/home` drop the query and RequireAuth bounce back to Catalog.
 * Regression: CatalogCodeBootstrap.test.jsx + RootRedirect.test.jsx + catalog.test.js
 */
export default function CatalogCodeBootstrap({ children }) {
  const { code, error } = useCatalogCodeHandoff()

  // Gate on `code`, not `busy` — first paint must not mount protected routes.
  if (code) {
    return (
      <main style={{ padding: 32, fontFamily: 'system-ui' }}>
        <Typography variant="h6">{error ? 'Sign-in failed' : 'Signing you in…'}</Typography>
        {error ? <Typography color="error">{String(error)}</Typography> : null}
      </main>
    )
  }

  return children
}
